//
const getTextfieldHeight = size => {
  switch (size) {
    case 'small':
      return '32px'
    case 'large':
      return '44'
    case 'medium':
    default:
      return '40px'
  }
}

export default getTextfieldHeight
